const List = ({ data, desc }) => {
  return (
    <>
      <ul>
        {data?.map((element, index) => (
          <li key={index}>{element}</li>
        ))}
      </ul>
      <p> {desc} </p>
    </>
  );
};

export default List;
